import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { ExpandableText } from "@sequentech/ui-essentials";
import { useEffect, useState } from "react";
import { useRecordContext } from "react-admin";
import { useTranslation } from "react-i18next";
/**
 * This component renders a string field with a show more/show less toggle.
 * The field is rendered as a text field with an ellipsis at the end when the string is longer than the initial length.
 * By default, the initial length is 256 characters.
 * When the user clicks on the field, the show more/show less toggle is displayed.
 * When the user clicks on the toggle, the field is rendered in its entirety or shortened to the initial length.
 * The toggle text is translated using the keys "electionEventScreen.common.showMore" and "electionEventScreen.common.showLess".
 * @param {MessageFieldProps} props
 * @param {string} [props.source] - The source of the data for the field if it is in the record context.
 * @param {string} [props.content] - The content of the field if is rendered directly from parent.
 * @param {number} [props.initialLength=256] - The initial length of the field.
 * @param {ReactNode} [props.details] - Shown under the full text once expanded.
 * @returns {ReactElement}
 */
export var MessageField = function (_a) {
    var source = _a.source, content = _a.content, _b = _a.initialLength, initialLength = _b === void 0 ? 256 : _b, details = _a.details;
    var t = useTranslation().t;
    var base = useRecordContext();
    var _c = useState(""), data = _c[0], setData = _c[1];
    useEffect(function () {
        if (base) {
            setData(content ? content : source ? base[source] : "");
        }
    }, [base, source, content]);
    return (_jsx(ExpandableText, { text: data, initialLength: initialLength, showMoreLabel: t("electionEventScreen.common.showMore"), showLessLabel: t("electionEventScreen.common.showLess"), details: details }));
};
